<template>
    <router-view />
</template>

<script>
export default {
    created() {
        let isUpdate = false;
        if (this.$route.params.id) isUpdate = true;

        if (this.$route.meta.contexto == "vendas") {
            this.permissao =  this.hasPermissionAccess(
                'vendas', 
                'clientes', 
                'ven-cliente')
        }else if(this.$route.meta.contexto == "promotor") {
            this.permissao =  this.hasPermissionAccess(
                'promotor', 
                'clientes', 
                'pro-cliente')
        } else if (this.$route.meta.contexto == "agro") {
            this.permissao =  this.hasPermissionAccess(
                'agro', 
                'clientes', 
                'agro-cliente');
        }

        if ((!isUpdate && !this.permissao.create) || (isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        }
    },
};
</script>
